export const calcFoldText = (value, prependZeroCount, ignoreNotPure) => {
    if (!value.replace(/,/g, '').match(/^[0-9]*\.[0-9]+$/))
        return;
    const [int, dec] = value.split('.');
    if (ignoreNotPure && +int > 0)
        return;
    let i = 0;
    for (; i < dec.length; i += 1)
        if (dec[i] !== '0')
            break;
    if (i < prependZeroCount)
        return;
    return [i, int.length + 1, int.length + 1 + i];
};
